module.exports = __webpack_public_path__ + "img/industry2.62e7dd6.jpg";